




































import { defineComponent, onUpdated, onMounted, computed, toRef } from '@vue/composition-api';

interface PropsInterface {
    id: number;
    value: string;
    mobileTextAfter?: string;
    mobileTextBefore?: string;
    content?: string;
    isHtml?: boolean;
    iconClass?: string;
    asTooltip?: boolean;
}

export default defineComponent({
    name: 'VehiclePopoverCell',
    props: {
        id: { type: Number, required: true },
        value: { type: String, required: true },
        mobileTextAfter: { type: String, required: false },
        mobileTextBefore: { type: String, required: false },
        content: { type: String, required: false },
        isHtml: { type: Boolean, default: false },
        iconClass: { type: String, default: '' },
        asTooltip: { type: Boolean, default: true }
    },
    setup (props: PropsInterface, { refs, root }) {
        const initPopover = () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            $(refs.popover).popover({
                trigger: props.asTooltip ? 'hover' : 'popover'
            });
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            $(refs.popoverMobile).popover({
                trigger: props.asTooltip ? 'hover' : 'popover'
            });
        };
        onUpdated(() => {
            root.$nextTick(initPopover);
        });
        onMounted(() => {
            root.$nextTick(initPopover);
        });

        const text = toRef(props, 'value');
        const beforeText = toRef(props, 'mobileTextBefore');
        const afterText = toRef(props, 'mobileTextAfter');
        const mobileText = computed(() => {
            if (beforeText.value) {
                return beforeText.value + ' ' + text.value;
            }
            if (afterText.value) {
                return text.value + ' ' + afterText.value;
            }
            return text.value;
        });
        return { mobileText };
    }
});
